import * as patientTypes from './types'
import * as patientActions from './actions'
import patientReducer from './reducer'

export {patientActions, patientTypes}

export default patientReducer
